import { gql } from "lib/apolloClient";
import { plannerElementNodeFragment } from "CommonGraphql/PlannerElementNode/PlannerElementNodeFragments";
import {
  resolvedFieldValueFragment as resolvedFields,
  pypElementFragment,
} from "modules/CommonFragments";

export const resolvedFieldValueFragment = {
  basicResolvedMinimalTree: gql`
    fragment basicResolvedMinimalTreeItem on ResolvedFieldValue {
      id
      type
      ... on ResolvedFieldPlannerElementSet {
        id
        type
        nodes {
          ...plannerElementNodeWithAssocParentsItem
        }
      }
      ... on ResolvedFieldSubjectSet {
        id
        subjects {
          id
          name
          benchmarkRootNode {
            id
          }
        }
      }
      ... on ResolvedFieldATLSet {
        id
        atls {
          id
          label
          parent
          children
          depth
        }
      }
      ... on ResolvedFieldBenchmarkSet {
        id
        type
        benchmarks {
          id
          label
          code
          children
          parent
          subject
          depth
          type
          isLeaf
          levelId
        }
      }
      ... on ResolvedFieldConceptSet {
        id
        type
        concepts {
          ...conceptItem
        }
      }
      ... on ResolvedFieldRelatedConceptSet {
        id
        type
        relatedConcepts {
          id
          label
          elementId
          elementType
          parent
          children
        }
      }
      ... on ResolvedFieldSubjectGroup {
        id
        type
        subjectGroups {
          id
          name
        }
      }
      ... on ResolvedFieldThemeSet {
        id
        type
        themes {
          ...themeItem
        }
        __typename
      }
      ... on ResolvedFieldLPSet {
        id
        type
        learnerProfiles {
          id
          label
          subText
          children
          parent
          levelId
        }
      }
      ...resolvedFieldVideoAttachmentItem
    }
    ${pypElementFragment.theme}
    ${pypElementFragment.concept}
    ${plannerElementNodeFragment.plannerElementNodeWithAssocParents}
    ${resolvedFields.resolvedFieldVideoAttachment}
  `,
  resolvedMinimalTree: gql`
    fragment resolvedMinimalTreeItem on ResolvedFieldValue {
      id
      type
      ... on ResolvedFieldPlannerElementSet {
        id
        type
        nodes {
          ...plannerElementNodeWithAssocParentsItem
        }
      }

      ... on ResolvedFieldSubjectGroup {
        id
        type
        subjectGroups {
          id
          name
        }
      }
      ...resolvedFieldVideoAttachmentItem
    }

    ${plannerElementNodeFragment.plannerElementNodeWithAssocParents}
    ${resolvedFields.resolvedFieldVideoAttachment}
  `,
};

export const fieldFragment = {
  unitPlanFieldBasicDetails: gql`
    fragment unitPlanFieldBasicDetailsItem on PlannerField {
      id
      uid
      value
      resolvedMinimalTree {
        ...basicResolvedMinimalTreeItem
      }
    }

    ${resolvedFieldValueFragment.basicResolvedMinimalTree}
  `,
  unitPlanFieldDetails: gql`
    fragment unitPlanFieldDetails on PlannerField {
      id
      uid
      value
      resolvedMinimalTree {
        ...resolvedMinimalTreeItem
      }
    }

    ${resolvedFieldValueFragment.resolvedMinimalTree}
  `,
};

export const plannerElementSetFragment = {
  plannerElementSetWithNodes: gql`
    fragment plannerElementSetWithNodesItem on PlannerElementSet {
      id
      label
      type
      nodes(filters: $filters) {
        ...plannerElementNodeItem
      }
    }
    ${plannerElementNodeFragment.plannerElementNode}
  `,
  plannerElementSetBasicDetails: gql`
    fragment plannerElementSetBasicDetailsItem on PlannerElementSet {
      id
      label
      type
      isIncludedInInsights
    }
  `,
};

export const programmeInsightsFragment = {
  programmeInsightsEdge: gql`
    fragment programmeInsightEdgeItem on PYPProgrammeInsightEdge {
      gradeInsight {
        grade {
          id
          name
        }
        unitPlans {
          id
        }
      }
      themeInsight {
        theme {
          id
          label
        }
        unitPlans {
          id
        }
      }
      gradeUnitPlans {
        id
      }
      themeUnitPlans {
        id
      }
    }
  `,
};
